
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import CrudLayout from "@/layouts/CrudLayout.vue";
import Validation from "@/components/Validation.vue";
import BottleSizeForm from "@/views/admin/bottle_size/BottleSizeForm.vue";

const namespace: string = "bottlesize";

@Component({
  components: {
    CrudLayout,
    Validation,
    BottleSizeForm
  }
})
export default class BottleSizeUpdate extends Vue {
  public name: string = "BottleSizeUpdate";
  private resourceName = "bottle-size";

  @Getter("getError", { namespace }) error: any;
  @Getter("isLoading", { namespace }) loading: any;
  @Getter("isUpdated", { namespace }) updated: any;
  @Getter("getItem", { namespace }) item: any;

  @Action("update", { namespace }) updateItemAction: any;
  @Action("findOne", { namespace }) getItemAction: any;
  @Action("resetUpdate", { namespace }) resetAction: any;

  protected back() {
    // TODO remember last table state (session storage)
    this.$router.push({ path: "/" + this.resourceName });
  }

  mounted() {
    this.getItemAction({
      resource: this.resourceName,
      id: Number.parseInt(this.$route.params.id)
    });
  }

  beforeDestroy() {
    this.resetAction();
  }
}
